export default "__VITE_ASSET__B$zOKtiX__"